import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TaskConsolidatedComponent } from './views/consolidated/task-consolidated.component';

const routes: Routes = [
  {
    path: '',
    component: TaskConsolidatedComponent,
    title: 'Tasks'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TaskRoutingModule { }
